import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Popover, PopoverContent, PopoverTrigger } from './popover';

interface FieldHelpPopoverProps {
  /** i18n translation key for the help text */
  helpKey: string;
  /** Namespace (defaults to 'help') */
  ns?: string;
}

/**
 * Contextual help popover that displays informational guidance
 * next to form field labels. Renders an info icon that opens
 * a popover with translated help text on click.
 *
 * @example
 * <Label>
 *   Stylesheet URL <FieldHelpPopover helpKey="stylesheetUrl" />
 * </Label>
 */
export function FieldHelpPopover({ helpKey, ns = 'help' }: FieldHelpPopoverProps) {
  const { t } = useTranslation(ns);

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="ml-1 inline-flex items-center text-muted-foreground hover:text-foreground transition-colors"
          aria-label={t('help:ariaLabel')}
        >
          <Info className="h-4 w-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-64 text-sm" side="top">
        {t(helpKey)}
      </PopoverContent>
    </Popover>
  );
}
